"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StepMapper_1 = __importDefault(require("../Wizard/StepMapper"));
var AccCustomersInfo_1 = __importDefault(require("./AccCustomersInfo"));
var AccInviteMembers_1 = __importDefault(require("./AccInviteMembers"));
var CompanyIntro_1 = __importDefault(require("./CompanyIntro"));
var ConnectAccSoftware_1 = __importDefault(require("./ConnectAccSoftware"));
var HudledExpectations_1 = __importDefault(require("./HudledExpectations"));
var RequestAudit_1 = __importDefault(require("./RequestAudit"));
var SaasQuiz_1 = __importDefault(require("./SaasQuiz"));
var TeamSetup_1 = __importDefault(require("./TeamSetup"));
var TrackSoftware_1 = __importDefault(require("./TrackSoftware"));
var UserIntro_1 = __importDefault(require("./UserIntro"));
var WizardParts_1 = require("./WizardParts");
var STEP_MAPPER = {
    USER_INTRO: UserIntro_1.default,
    COMPANY_INTRO: CompanyIntro_1.default,
    SET_ACCOUNTING: ConnectAccSoftware_1.default,
    CONNECT_ACCOUNTING: function () { return null; },
    TRACK_SOFTWARE: TrackSoftware_1.default,
    TRACK_SOFTWARE_TEAM: TrackSoftware_1.default,
    HUDLED_EXPECTATIONS: HudledExpectations_1.default,
    SETUP_TEAM: TeamSetup_1.default,
    SAAS_QUIZ: SaasQuiz_1.default,
    REQUEST_AUDIT: RequestAudit_1.default,
    ACC_CUSTOMERS_INFO: AccCustomersInfo_1.default,
    ACC_INVITE_MEMBERS: AccInviteMembers_1.default,
};
var WelcomeFlowSteps = (0, StepMapper_1.default)(STEP_MAPPER, WizardParts_1.WizardContext);
exports.default = WelcomeFlowSteps;
